import React from 'react'
import SectionList from './SectionList'
import './Sections.css'

const Sections = () => {
  return (
    <div>
      <SectionList />
    </div>
  )
}

export default Sections
